import { render, staticRenderFns } from "./hjlbTJ.vue?vue&type=template&id=be945b66&scoped=true"
import script from "./hjlbTJ.vue?vue&type=script&lang=js"
export * from "./hjlbTJ.vue?vue&type=script&lang=js"
import style0 from "./hjlbTJ.vue?vue&type=style&index=0&id=be945b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be945b66",
  null
  
)

export default component.exports